export const APP_THEME_STORAGE_KEY = 'app-theme';

export const APP_THEME_CHANGE_EVENT = 'wafer-app-theme-change';

export type ThemeMode = 'light' | 'dark';

export function readStoredThemeMode(): ThemeMode {
  const saved = localStorage.getItem(APP_THEME_STORAGE_KEY);
  return saved === 'dark' || saved === 'light' ? saved : 'light';
}

export function writeStoredThemeMode(mode: ThemeMode): void {
  localStorage.setItem(APP_THEME_STORAGE_KEY, mode);
}

export function publishThemeModeChange(mode: ThemeMode): void {
  window.dispatchEvent(new CustomEvent<ThemeMode>(APP_THEME_CHANGE_EVENT, { detail: mode }));
}

export function subscribeThemeModeChange(listener: (mode: ThemeMode) => void): () => void {
  const handler = (event: Event) => {
    const mode = (event as CustomEvent<ThemeMode>).detail;
    if (mode === 'light' || mode === 'dark') {
      listener(mode);
    }
  };
  window.addEventListener(APP_THEME_CHANGE_EVENT, handler);
  return () => window.removeEventListener(APP_THEME_CHANGE_EVENT, handler);
}
